<template>
  <div class="news-panel">
    <convert-points v-if="userPanel.Action === 'convert_points'" :module="userPanel"/>
    <change-password v-else-if="userPanel.Action === 'change_password'" :module="userPanel"/>
    <change-email v-else-if="userPanel.Action === 'change_email'" :module="userPanel"/>
    <top-up v-else-if="userPanel.Action === 'topup'" :module="userPanel"/>
    <item-shop v-else-if="userPanel.Action === 'item_shop'" :module="userPanel"/>
    <item-shop-add v-else-if="userPanel.Action === 'add_item_shop'" :module="userPanel"/>
    <add-main-event-image v-else-if="userPanel.Action === 'add_main_event_image'" :module="userPanel"/>
    <download-link-add v-else-if="userPanel.Action === 'add_download_link'" :module="userPanel"/>
    <server-info-add v-else-if="userPanel.Action === 'edit_server_info'" :module="userPanel"/>
    <events-add v-else-if="userPanel.Action === 'add_event'" :module="userPanel"/>
    <auction-item-add v-else-if="userPanel.Action === 'add_auction'" :module="userPanel"/>
    <auction-item-page v-else-if="userPanel.Action === 'auction_items'" :module="userPanel"/>
    <change-pin v-else-if="userPanel.Action === 'change_pin'" :module="userPanel"/>
    <shop-logs v-else-if="userPanel.Action === 'shop_logs'" :module="userPanel"/>
    <create-ticket v-else-if="userPanel.Action === 'create_ticket'" :module="userPanel"/>
    <ticket-list v-else-if="userPanel.Action === 'your_ticket'" :module="userPanel"/>
    <night-market-page v-else-if="userPanel.Action === 'night_market'" :module="userPanel"/>
    <create-night-market v-else-if="userPanel.Action === 'create_night_market'" :module="userPanel"/>
    <user-list v-else-if="userPanel.Action === 'user_management'" :module="userPanel"/>
    <topup-logs v-else-if="userPanel.Action === 'topup_logs'" :module="userPanel"/>
    <update-item-list v-else-if="userPanel.Action === 'update_item_list'" :module="userPanel" />
  </div>
</template>

<script>
import ConvertPoints from '@/components/user-panel/contents/ConvertPoints.vue'
import ChangePassword from '@/components/user-panel/contents/ChangePassword.vue'
import ChangeEmail from '@/components/user-panel/contents/ChangeEmail.vue'
import TopUp from '@/components/user-panel/contents/TopUp.vue'
import ItemShop from '@/components/user-panel/contents/item-shop/ItemShopPage.vue'
import ItemShopAdd from '@/components/user-panel/contents/item-shop/ItemShopAdd.vue'
import AddMainEventImage from '@/components/user-panel/contents/main-event-image/AddMainEventImage.vue'
import DownloadLinkAdd from '@/components/user-panel/contents/download-link/DownloadLinkAdd.vue'
import ServerInfoAdd from '@/components/user-panel/contents/server-info/ServerInfoAdd.vue'
import EventsAdd from '@/components/user-panel/contents/add-events/EventsAdd.vue'
import AuctionItemAdd from '@/components/user-panel/contents/auctions/AuctionItemAdd.vue'
import AuctionItemPage from '@/components/user-panel/contents/auctions/AutionItemPage.vue'
import ChangePin from '@/components/user-panel/contents/ChangePin.vue'
import ShopLogs from '@/components/user-panel/contents/shop-logs/ShopLogs.vue'
import CreateTicket from '@/components/user-panel/contents/ticket/CreateTicket.vue'
import TicketList from '@/components/user-panel/contents/ticket/TicketList.vue'
import NightMarketPage from '@/components/user-panel/contents/night-market/NightMarketPage.vue'
import CreateNightMarket from '@/components/user-panel/contents/night-market/CreateNightMarket.vue'
import UserList from '@/components/user-panel/contents/user-management/UserList.vue'
import TopupLogs from '@/components/user-panel/contents/topup-logs/TopupLogs'
// import AddDonationDetails from '@/components/user-panel/contents/add-donation-details/AddDonationDetails'
import UpdateItemList from '@/components/user-panel/contents/item-list/UpdateItemList'

export default {
  name: 'NewsPanel',
  components: {
    ConvertPoints,
    ChangePassword,
    ChangeEmail,
    TopUp,
    ItemShop,
    ItemShopAdd,
    AddMainEventImage,
    DownloadLinkAdd,
    ServerInfoAdd,
    EventsAdd,
    AuctionItemAdd,
    AuctionItemPage,
    ChangePin,
    ShopLogs,
    CreateTicket,
    TicketList,
    NightMarketPage,
    CreateNightMarket,
    UserList,
    TopupLogs,
    // AddDonationDetails,
    UpdateItemList
  },
  props: {
    userPanel: {
      require: true,
      type: Object
    }
  }
}
</script>
<style lang="scss">
  .news-panel {
    display: grid;
    grid-template-rows: 1fr;
    gap: 16px;
  }
</style>